// Domain types for Sender Persona feature

export interface AdditionalPhoneNumber {
  countryCode: string;
  channel: "IM" | "VOICE";
  phoneNo: string;
}

export interface SenderPersona {
  id?: number;
  agentType: string;
  name: string;
  aiIdentifier: string;
  description?: string;
  languagePreference: string;
  emailFrom: string;
  emailAddress: string;
  tone?: string;
  greeting?: string;
  signature?: string;
  imPhoneNo?: string;
  voicePhoneNo?: string;
  imCountryCode?: string;
  voiceCountryCode?: string;
  additionalPhoneNumbers?: AdditionalPhoneNumber[];
}

export interface SenderPersonaFormData extends Omit<SenderPersona, 'id'> {
  agentType: string;
  imPhoneNo?: string;
  voicePhoneNo?: string;
  imCountryCode?: string;
  voiceCountryCode?: string;
}

export const LANGUAGES = [
  { value: 'English', label: 'English' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'French', label: 'French' },
  { value: 'German', label: 'German' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Hindi', label: 'Hindi' },
] as const;

export interface CountryDto {
  id: number;
  countryCode: string;
  countryName: string;
  isdCode: string;
  startWorkingHour?: string;
  endWorkingHour?: string;
}
